import './styles.css.js';
import { useClassNames } from '@magnetic/hooks';
import React, { createElement } from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const Group = /* @__PURE__ */ __name(({
  as,
  children,
  className,
  ...rest
}) => {
  const Component = as != null ? as : "div";
  const classNames = useClassNames("mds-button-group", className);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, createElement(Component, { ...rest, className: classNames }, children));
}, "Group");
Group.displayName = "Button.Group";

export { Group };
//# sourceMappingURL=index.js.map
